import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Card, CardBody, CardTitle } from '@spark/ui-components/components/Card';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import ConfirmDeleteModal from '../../UI/Modals/index2';
import DadosGerais from './components/DadosGerais';
import { useViagemDetalhes } from './hooks/useViagemDetalhes';
import styled from 'styled-components';

const ViagemDetalhes = () => {
  const {
    viagem,
    loading,
    deleting,
    showDeleteModal,
    setShowDeleteModal,
    handleEditar,
    handleVoltar,
    handleExcluir,
    confirmDelete
  } = useViagemDetalhes();

  if (loading) {
    return (
      <Container fluid>
        <Row>
          <Col md={12}>
            <div style={{ textAlign: 'center', padding: '50px' }}>
              Carregando detalhes da viagem...
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  if (!viagem) {
    return (
      <Container fluid>
        <Row>
          <Col md={12}>
            <div style={{ textAlign: 'center', padding: '50px' }}>
              Viagem não encontrada
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader
            title=""
            routeSegments={[
              { name: 'Início' },
              { name: 'Viagens', path: '/pages/viagens' },
              { name: 'Detalhes da Viagem' }
            ]}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <HeaderWrap>
                <CardTitle>Detalhes da Viagem</CardTitle>
                <ButtonContainer>
                  <ButtonWithLoading variant="primary" onClick={handleEditar}>
                    Editar
                  </ButtonWithLoading>
                  <ButtonWithLoading variant="danger" onClick={handleExcluir}>
                    Excluir
                  </ButtonWithLoading>
                  <ButtonWithLoading variant="secondary" onClick={handleVoltar}>
                    Voltar
                  </ButtonWithLoading>
                </ButtonContainer>
              </HeaderWrap>

              <DadosGerais viagem={viagem} />
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* Modal de confirmação de exclusão */}
      <ConfirmDeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={confirmDelete}
        loading={deleting}
      />
    </Container>
  );
};

export default ViagemDetalhes;

// Estilos
const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
